module.exports = __webpack_public_path__ + "static/img/cyx3.bbf6fbbc.png";